
import { createI18n } from 'vue-i18n'
import en from './en'
import zhCN from './zh'
 
const locallang = function(){
  let lang =  navigator.language;
  
  let retlang = 'en';
  if (/^zh\b/.test(lang))
  {
    retlang = 'zh';
  }
  else
  {
    retlang = 'en';
  }

  return retlang;
}


// console.log('locallang',locallang());

const i18n = createI18n({
  legacy: false, 
  locale: locallang(), // 初始化显示英文en zh
  messages: {
    'en' : en,
    'zh' : zhCN
    } // 这里就是你有几种语言，对象里面就有几个
})
 
export default i18n